import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '@core/auth';
import { ResponsiveService } from '@core/services';

export const defaultRouteGuard: CanActivateFn = () => {
  const session = inject(SessionService);
  const router = inject(Router);

  if (session.isSuperAdministrator || session.isAdministrator || session.isPlanner) {
    return router.createUrlTree(['/planning']);
  }

  if (session.isMitarbeiter) {
    return router.createUrlTree(['/my']);
  }

  if (session.isBetriebsrat) {
    return router.createUrlTree(['/audit']);
  }

  if (session.isInfo) {
    return router.createUrlTree(['/kalender']);
  }

  return router.createUrlTree(['/messages']);
};

export const mobileTabletRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const responsive = inject(ResponsiveService);

  if (responsive.$isMobile() || responsive.$isTablet()) {
    return router.createUrlTree(['/messages']);
  }

  return true;
};

export const mobileRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const responsive = inject(ResponsiveService);

  if (responsive.$isMobile()) {
    return router.createUrlTree(['/messages']);
  }

  return true;
};
